<template>
  <!-- 对接详情中部内容 -->
  <div class="DockingDetailsCenter main">
    <div class="content">
      <el-row>
        <el-col class="contentLeft" :xs="24" :sm="1">
          <!-- 对接详情-鼓掌-点赞-分享 -->
          <DockingDetailsCenterLeftContent />
        </el-col>
        <el-col class="contentRight" :xs="24" :sm="23">
          <el-row>
            <el-col class="contentRight" :xs="24" >
              <!-- 对接详情-项目介绍 -->
              <DockingDetailsCenterRightContent :msg="msg" />
            </el-col>
          
            <el-col class="contentRight" :xs="24">
              <!-- 对接详情-嘉宾 -->
              <Guest  :list="msg.guest"/>
            </el-col>
          
            <el-col class="contentRight" :xs="24" >
              <!-- 对接详情-发言 -->
              <Speak  :id="msg.id"/>
            </el-col>
          </el-row>
        </el-col>



      </el-row>

    </div>
   
  </div>
</template>

<script>
  import DockingDetailsCenterLeftContent from "@/components/DockingSystem/Content/DockingDetailsCenterLeftContent.vue"; //对接详情中部左侧内容
  import DockingDetailsCenterRightContent from "@/components/DockingSystem/Content/DockingDetailsCenterRightContent.vue"; //对接详情中部右侧内容
  import Guest from "@/components/DockingSystem/DockingDetails/Guest.vue"; //对接系统嘉宾
  import Speak from "@/components/DockingSystem/DockingDetails/Speak.vue"; //对接系统发言

  export default {
    props: {
      msg: Object
    },
    components: {
      DockingDetailsCenterLeftContent,
      DockingDetailsCenterRightContent,
      Guest,
      Speak,

    },
    data() {
      return {};
    },
    created: function () { },
    methods: {},
  };
</script>

<style scoped>
  @media (max-width: 768px) {
    .DockingDetailsCenter {
      padding: 0 !important;
    }
  }

  .DockingDetailsCenter {
    margin-top: 41px;

  }

  .opacityZero {
    opacity: 0;
  }
</style>